import { render, staticRenderFns } from "./AddButton.vue?vue&type=template&id=4dcc8917"
import script from "./AddButton.vue?vue&type=script&lang=ts"
export * from "./AddButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports